
import { colorKeywordToRGB, rgbBackgroundToTextColor } from "../../../Utils/Functions/helpers";
import styles from "./SRFButton.module.css"
  
  // MyComponent.jsx

const SRFButton = ({color = "rgb(32, 52, 106)", type, children, width, ...rest}) => (
    <button
        style={{"--color": color, "--text-color": rgbBackgroundToTextColor(colorKeywordToRGB(color)), width}}
        className={styles.SRFButton}
        type={type ? type : "button"}
        //className={`text-white enabled:bg-red-700 disabled:cursor-not-allowed disabled:bg-red-300 enabled:hover:bg-red-800 enabled:focus:ring-4 enabled:focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 me-2 dark:bg-red-600 dark:hover:bg-red-700 focus:outline-none dark:focus:ring-red-800`}
        {...rest}
    >
        {children}
    </button>
);

export default SRFButton;